import React from 'react';
import { motion } from 'framer-motion';
import { MessageCircle } from 'lucide-react';
import { socialLinks } from '../mock';

const WhatsAppFloat = () => {
  return (
    <motion.a
      href={socialLinks.whatsapp}
      target="_blank"
      rel="noopener noreferrer"
      initial={{ opacity: 0, scale: 0 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ delay: 2, duration: 0.5, type: 'spring' }}
      whileHover={{ scale: 1.1 }}
      whileTap={{ scale: 0.95 }}
      className="fixed bottom-6 right-6 z-40 w-14 h-14 md:w-16 md:h-16 rounded-full bg-[#25D366] shadow-2xl flex items-center justify-center hover:bg-[#1EBE57] transition-colors duration-300 group"
      data-testid="whatsapp-float-btn"
      aria-label="Contattaci su WhatsApp"
    >
      {/* Pulsing ring */}
      <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-20" />
      
      <MessageCircle className="w-7 h-7 md:w-8 md:h-8 text-white relative z-10" fill="white" />
      
      {/* Tooltip on hover */}
      <span className="absolute right-full mr-3 bg-[#2A2520] text-[#F5F1E8] text-xs px-3 py-2 whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none">
        Scrivici su WhatsApp
      </span>
    </motion.a>
  );
};

export default WhatsAppFloat;
